import React, { useState, useContext } from 'react';
import { supabase } from '../supabaseClient';
import { ThemeContext } from '../App';

export default function CompletarPerfil({ userId, email, onConcluido }) {
  const { darkMode } = useContext(ThemeContext);
  const [nome, setNome] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const handleSalvar = async (e) => {
    e.preventDefault();
    const nomeTrimmed = nome.trim();
    if (nomeTrimmed.length < 2) {
      setErro('Por favor, informe seu nome completo.');
      return;
    }
    setSalvando(true);
    setErro('');
    const { error } = await supabase
      .from('usuarios')
      .update({ nome: nomeTrimmed })
      .eq('id', userId);
    setSalvando(false);
    if (error) {
      setErro('Erro ao salvar. Tente novamente.');
      return;
    }
    onConcluido(nomeTrimmed);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.7)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: darkMode ? '#1e1e1e' : '#fff',
        borderRadius: 20,
        maxWidth: 420,
        width: '100%',
        boxShadow: '0 8px 40px rgba(0,0,0,0.35)',
        overflow: 'hidden',
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #1565c0 0%, #43cea2 100%)',
          padding: '20px 24px',
        }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: '#fff' }}>👋 Bem-vindo ao Climorax!</div>
          <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', marginTop: 4 }}>
            Complete seu cadastro para continuar
          </div>
        </div>

        {/* Body */}
        <form onSubmit={handleSalvar} style={{ padding: '24px' }}>
          <p style={{ color: darkMode ? '#ccc' : '#555', fontSize: 14, margin: '0 0 20px', lineHeight: 1.6 }}>
            Sua conta foi criada com o email <strong>{email}</strong>.<br />
            Informe seu nome para personalizar sua experiência.
          </p>

          <label style={{
            display: 'block',
            fontWeight: 600,
            fontSize: 14,
            color: darkMode ? '#90caf9' : '#1976d2',
            marginBottom: 6
          }}>
            Seu nome completo
          </label>
          <input
            type="text"
            placeholder="Ex: João da Silva"
            value={nome}
            onChange={e => setNome(e.target.value)}
            autoFocus
            style={{
              width: '100%',
              padding: '12px 14px',
              borderRadius: 10,
              border: `2px solid ${darkMode ? '#90caf9' : '#1976d2'}`,
              fontSize: 16,
              background: darkMode ? '#2a2a2a' : '#f8fafc',
              color: darkMode ? '#f0f0f0' : '#222',
              boxSizing: 'border-box',
              outline: 'none',
              marginBottom: 8,
            }}
          />
          {erro && (
            <p style={{ color: '#d32f2f', fontSize: 13, margin: '0 0 12px' }}>{erro}</p>
          )}

          {/* Instrução de senha */}
          <div style={{
            background: darkMode ? '#2a2000' : '#fff8e1',
            border: '1px solid #ffa000',
            borderLeft: '4px solid #ffa000',
            borderRadius: 6,
            padding: '10px 14px',
            marginBottom: 20,
          }}>
            <p style={{ margin: 0, color: darkMode ? '#ffcc80' : '#e65100', fontSize: 13, lineHeight: 1.5 }}>
              🔑 Para definir uma senha de acesso: saia do app e use <strong>Esqueci minha senha</strong> na tela de login com o email acima.
            </p>
          </div>

          <button
            type="submit"
            disabled={salvando}
            style={{
              width: '100%',
              padding: '13px 0',
              borderRadius: 12,
              border: 'none',
              background: nome.trim().length >= 2
                ? 'linear-gradient(135deg, #1565c0 0%, #43cea2 100%)'
                : '#ccc',
              color: '#fff',
              fontSize: 16,
              fontWeight: 700,
              cursor: nome.trim().length >= 2 ? 'pointer' : 'not-allowed',
              transition: 'background 0.2s',
            }}
          >
            {salvando ? 'Salvando...' : 'Continuar →'}
          </button>
        </form>
      </div>
    </div>
  );
}
